'use strict';

var List = require("bs-platform/lib/js/list.js");
var RandomString = require("../Js/randomString").default;

function randomString(prim) {
  return RandomString();
}

function listOfRange(start, end_) {
  if (start === end_) {
    return {
            hd: end_,
            tl: /* [] */0
          };
  } else {
    return List.append({
                hd: start,
                tl: /* [] */0
              }, listOfRange(start + 1 | 0, end_));
  }
}

exports.randomString = randomString;
exports.listOfRange = listOfRange;
/* ../Js/randomString Not a pure module */
